import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param data Object
 * @param organisation OrganisationModel
 * @return {Promise<any>|Promise}
 */
export default (function (data, organisation) {
    var url = applyPathVariables(EndPoints.SERVICE_ENTRIES, { organisationId: organisation.id });
    var request = new Request({ method: Methods.POST, url: url, withCredentials: true, data: data });
    return request.execute();
});
